import { Container } from '@material-ui/core'
import Menu from '../../section/Menu/menu'
import Header from '../../section/Header/header'
import SocialSection from '../../section/SocialSection/Socialsection'
import About from '../../section/About/about'
import Feature from '../../section/Feature/feature'
import Roadmap from '../../section/Roadmap/roadmap'
import Tokenomics from '../../section/Tokenomics/tokenomics'
import FAQ from '../../section/FAQ/faq'
import Footer from '../../Components/Footer'

function App() {
  return (
    <div className="App" >
      <Menu />
      <Header />
      {/* <SocialSection /> */}
      <About />
      <Feature />
      <Roadmap />
      <Tokenomics />
      <FAQ />
      <Container maxWidth="xl">
        <Footer />
      </Container>
    </div>
  );
}

export default App;
